// extracted by css-extract-rspack-plugin
export default {"Nav":"Nav-module__Nav__OwpQ4Z9"};